export default {
    name: 'reports',
    props: ['reports_data','report_type','selected_revenue_type'],
    data(){
        return{
            records_count:10,
            page_number:0,
            name_ascending:false,
            name_sort:false,
            last_visit_ascending:false,
            last_visit_sort:false,
            total_bookings_ascending:false,
            total_bookings_sort:false,
            total_cancled_ascending:false,
            total_cancled_sort:false,
            total_no_show_ascending:false,
            total_no_show_sort:false,
            total_sales_ascending:true,
            total_sales_sort:true,
            show_name_sort_indication:false,
            show_visit_sort_indication:false,
            show_booking_sort_indication:false,
            show_cancel_sort_indication:false,
            show_no_show_sort_indication:false,
            show_sales_sort_indication:false,
            revenue_name_sort_indication:false,
            revenue_name_sort:false,
            revenue_name_ascending:false,
            product_sales_sort_indication:false,
            product_sales_sort:false,
            product_sales_ascending:false,
            product_instore_sort_indication:false,
            product_instore_ascending:false,
            product_instore_sort:false,
            product_online_sort_indication:false,
            product_online_ascending:false,
            product_online_sort:false,
            revenue_total_bookings_sort_indication:false,
            revenue_total_bookings_sort:false,
            revenue_cancel_sort_indication:false,
            revenue_cancel_bookings_sort:false,
            revenue_no_show_sort_indication:false,
            revenue_no_show_sort:false,
            staff_available_sort_indication:false,
            staff_available_sort:false,
            total_revenue_sort_indication:false,
            revenue_cancel_bookings_ascending:false,
            revenue_total_bookings_ascending:false,
            revenue_no_show_ascending:false,
            staff_available_ascending:false,
            total_revenue_ascending:true,
            total_revenue_sort:true,
            table_data:[],
            number_of_pages:0,
            windowHeight : window.innerHeight - 270,
            url: 'https://' + window.location.hostname + '/index.php/',
        }
    },
    components: {
    },
    created(){
    },
    mounted(){
        
    },
  computed : {
      show_reports(){
        if(this.reports_data.length > 0){
            if(this.$session.get("updated_table_date")){
                this.page_number = 0;
                if(this.report_type == 'Customer Reports'){
                    this.name_sort = false;
                    this.last_visit_sort = false;
                    this.total_bookings_sort = false;
                    this.total_cancled_sort = false;
                    this.total_no_show_sort = false;
                    this.total_sales_sort = true;
                    this.total_sales_ascending = true;
                    this.name_ascending = false;
                    this.last_visit_ascending = false;
                    this.total_bookings_ascending = false;
                    this.total_cancled_ascending = false;
                    this.total_no_show_ascending = false;
                }
                else if(this.report_type == 'Revenue Reports'){
                    this.total_revenue_sort = true;
                    this.staff_available_sort= false;
                    this.revenue_no_show_sort =false;
                    this.revenue_cancel_bookings_sort = false;
                    this.revenue_total_bookings_sort = false;
                    this.product_online_sort = false;
                    this.product_instore_sort = false;
                    this.product_sales_sort = false;
                    this.revenue_name_sort = false;
                    this.total_revenue_ascending = true;
                    this.revenue_cancel_bookings_ascending = false;
                    this.revenue_total_bookings_ascending = false;
                    this.revenue_no_show_ascending = false;
                    this.staff_available_ascending = false;
                    this.revenue_name_ascending = false;
                    this.product_sales_ascending = false;
                    this.product_instore_ascending = false;
                    this.product_online_ascending = false;
                }
            }
            this.$session.set("updated_table_date",false)
            this.reports()
        }
        else this.table_data = []
        if(this.selected_revenue_type)console.log(this.selected_revenue_type);
        if(this.report_type)console.log(this.report_type);
      }
    
    },
    methods:{
        change_page_count(value){
            this.records_count = value;
            this.page_number = 0
        },
        reports(){
            this.table_data = [];
            var start_point = this.records_count*this.page_number;
            for(var index = 0;(index < this.records_count && start_point < this.reports_data.length);index++){
                this.table_data.push(this.reports_data[start_point]);
                start_point++;
            }
            this.number_of_pages = Math.ceil(this.reports_data.length/this.records_count);
        },
        change_page_number(condition){
            if(condition == 'remove'){
                this.page_number = this.page_number - 1;
            }else if(condition == 'add'){
                this.page_number = this.page_number + 1;
            }
            this.reports();
        },
        sort_json(type){

            this.page_number = 0;
            if(this.report_type == 'Customer Reports'){
                if(type == 'name'){
                    this.name_sort = true;
                    this.last_visit_sort = false;
                    this.total_bookings_sort = false;
                    this.total_cancled_sort = false;
                    this.total_no_show_sort = false;
                    this.total_sales_sort = false;
                    this.name_ascending = !this.name_ascending;
                    this.reports_data.sort(this.GetSortOrder_for_strings("book_first_name",this.name_ascending));
                }
                if(type == 'last visit'){
                    this.name_sort = false;
                    this.last_visit_sort = true;
                    this.total_bookings_sort = false;
                    this.total_cancled_sort = false;
                    this.total_no_show_sort = false;
                    this.total_sales_sort = false;
                    this.last_visit_ascending = !this.last_visit_ascending;
                    this.reports_data.sort(this.GetSortOrder("last_booking_date",this.last_visit_ascending));
                }
                if(type == 'total bookings'){
                    this.name_sort = false;
                    this.last_visit_sort = false;
                    this.total_bookings_sort = true;
                    this.total_cancled_sort = false;
                    this.total_no_show_sort = false;
                    this.total_sales_sort = false;
                    this.total_bookings_ascending = !this.total_bookings_ascending;
                    this.reports_data.sort(this.GetSortOrder("total_visits",this.total_bookings_ascending));
                }
                if(type == 'cancel'){
                    this.name_sort = false;
                    this.last_visit_sort = false;
                    this.total_bookings_sort = false;
                    this.total_cancled_sort = true;
                    this.total_no_show_sort = false;
                    this.total_sales_sort = false;
                    this.total_cancled_ascending = !this.total_cancled_ascending;
                    this.reports_data.sort(this.GetSortOrder("cancel",this.total_cancled_ascending));
                }
                if(type == 'no show'){
                    this.name_sort = false;
                    this.last_visit_sort = false;
                    this.total_bookings_sort = false;
                    this.total_cancled_sort = false;
                    this.total_no_show_sort = true;
                    this.total_sales_sort = false;
                    this.total_no_show_ascending = !this.total_no_show_ascending;
                    this.reports_data.sort(this.GetSortOrder("no_show",this.total_no_show_ascending));
                }
                if(type == 'total sales'){
                    this.name_sort = false;
                    this.last_visit_sort = false;
                    this.total_bookings_sort = false;
                    this.total_cancled_sort = false;
                    this.total_no_show_sort = false;
                    this.total_sales_sort = true;
                    this.total_sales_ascending = !this.total_sales_ascending;
                    this.reports_data.sort(this.GetSortOrder("total_sales",this.total_sales_ascending));
                }
            }
            else if(this.report_type == 'Revenue Reports'){
                if(type == 'service name'){
                    this.revenue_name_sort = true;
                    this.product_sales_sort = false;
                    this.product_instore_sort = false;
                    this.product_online_sort = false;
                    this.revenue_total_bookings_sort = false;
                    this.revenue_no_show_sort =false;
                    this.revenue_cancel_bookings_sort = false;
                    this.total_revenue_sort = false;
                    this.revenue_name_ascending = !this.revenue_name_ascending;
                    this.reports_data.sort(this.GetSortOrder_for_strings("service_name",this.revenue_name_ascending));
                }
                if(type == 'product name'){
                    this.revenue_name_sort = true;
                    this.product_sales_sort = false;
                    this.product_instore_sort = false;
                    this.product_online_sort = false;
                    this.revenue_total_bookings_sort = false;
                    this.revenue_no_show_sort =false;
                    this.revenue_cancel_bookings_sort = false;
                    this.total_revenue_sort = false;
                    this.revenue_name_ascending = !this.revenue_name_ascending;
                    this.reports_data.sort(this.GetSortOrder_for_strings("product_name",this.revenue_name_ascending));
                }
                if(type == 'class name'){
                    this.revenue_name_sort = true;
                    this.product_sales_sort = false;
                    this.product_instore_sort = false;
                    this.product_online_sort = false;
                    this.revenue_total_bookings_sort = false;
                    this.revenue_no_show_sort =false;
                    this.revenue_cancel_bookings_sort = false;
                    this.total_revenue_sort = false;
                    this.revenue_name_ascending = !this.revenue_name_ascending;
                    this.reports_data.sort(this.GetSortOrder_for_strings("class_name",this.revenue_name_ascending));
                }
                if(type == 'stylist name'){
                    this.revenue_name_sort = true;
                    this.product_sales_sort = false;
                    this.product_instore_sort = false;
                    this.product_online_sort = false;
                    this.revenue_total_bookings_sort = false;
                    this.revenue_no_show_sort =false;
                    this.revenue_cancel_bookings_sort = false;
                    this.total_revenue_sort = false;
                    this.revenue_name_ascending = !this.revenue_name_ascending;
                    this.reports_data.sort(this.GetSortOrder_for_strings("stylist_name",this.revenue_name_ascending));
                }
                if(type == 'total sales'){
                    this.product_sales_sort = true;
                    this.revenue_name_sort = false;
                    this.product_instore_sort = false;
                    this.product_online_sort = false;
                    this.revenue_total_bookings_sort = false;
                    this.revenue_no_show_sort =false;
                    this.revenue_cancel_bookings_sort = false;
                    this.total_revenue_sort = false;
                    this.product_sales_ascending = !this.product_sales_ascending;
                    this.reports_data.sort(this.GetSortOrder("total_bookings",this.product_sales_ascending));
                }
                if(type == 'instore'){
                    this.product_instore_sort = true;
                    this.product_sales_sort = false;
                    this.revenue_name_sort = false;
                    this.product_online_sort = false;
                    this.revenue_total_bookings_sort = false;
                    this.revenue_no_show_sort =false;
                    this.revenue_cancel_bookings_sort = false;
                    this.total_revenue_sort = false;
                    this.product_instore_ascending = !this.product_instore_ascending;
                    this.reports_data.sort(this.GetSortOrder("store",this.product_instore_ascending));
                }
                if(type == 'online'){
                    this.product_online_sort = true;
                    this.product_instore_sort = false;
                    this.product_sales_sort = false;
                    this.revenue_name_sort = false;
                    this.revenue_total_bookings_sort = false;
                    this.revenue_no_show_sort =false;
                    this.revenue_cancel_bookings_sort = false;
                    this.total_revenue_sort = false;
                    this.product_online_ascending = !this.product_online_ascending;
                    this.reports_data.sort(this.GetSortOrder("online",this.product_online_ascending));
                }
                if(type == 'total bookings'){
                    this.revenue_total_bookings_sort = true;
                    this.product_online_sort = false;
                    this.product_instore_sort = false;
                    this.product_sales_sort = false;
                    this.revenue_name_sort = false;
                    this.revenue_no_show_sort =false;
                    this.revenue_cancel_bookings_sort = false;
                    this.total_revenue_sort = false;
                    this.revenue_total_bookings_ascending = !this.revenue_total_bookings_ascending;
                    this.reports_data.sort(this.GetSortOrder("total_bookings",this.revenue_total_bookings_ascending));
                }
                if(type == 'cancel'){
                    this.revenue_cancel_bookings_sort = true;
                    this.revenue_total_bookings_sort = false;
                    this.product_online_sort = false;
                    this.product_instore_sort = false;
                    this.product_sales_sort = false;
                    this.revenue_name_sort = false;
                    this.revenue_no_show_sort =false;
                    this.total_revenue_sort = false;
                    this.revenue_cancel_bookings_ascending = !this.revenue_cancel_bookings_ascending;
                    this.reports_data.sort(this.GetSortOrder("cancelled",this.revenue_cancel_bookings_ascending));
                }
                if(type == 'no show'){
                    this.revenue_no_show_sort =true;
                    this.revenue_cancel_bookings_sort = false;
                    this.revenue_total_bookings_sort = false;
                    this.product_online_sort = false;
                    this.product_instore_sort = false;
                    this.product_sales_sort = false;
                    this.revenue_name_sort = false;
                    this.total_revenue_sort = false;
                    this.revenue_no_show_ascending = !this.revenue_no_show_ascending;
                    this.reports_data.sort(this.GetSortOrder("no_show",this.revenue_no_show_ascending));
                }
                if(type == 'available'){
                    this.staff_available_sort= true;
                    this.revenue_no_show_sort =false;
                    this.revenue_cancel_bookings_sort = false;
                    this.revenue_total_bookings_sort = false;
                    this.product_online_sort = false;
                    this.product_instore_sort = false;
                    this.product_sales_sort = false;
                    this.revenue_name_sort = false;
                    this.total_revenue_sort = false;
                    this.staff_available_ascending = !this.staff_available_ascending;
                    this.reports_data.sort(this.GetSortOrder("available_hrs",this.staff_available_ascending));
                }
                if(type == 'total revenue'){
                    this.total_revenue_sort = true;
                    this.staff_available_sort= false;
                    this.revenue_no_show_sort =false;
                    this.revenue_cancel_bookings_sort = false;
                    this.revenue_total_bookings_sort = false;
                    this.product_online_sort = false;
                    this.product_instore_sort = false;
                    this.product_sales_sort = false;
                    this.revenue_name_sort = false;
                    this.total_revenue_ascending = !this.total_revenue_ascending;
                    this.reports_data.sort(this.GetSortOrder("total_revenue",this.total_revenue_ascending));
                }

            }
        },
        GetSortOrder(prop,order) {
            if(order){
                return function(a, b) {    
                    if (a[prop] > b[prop]) {    
                        return 1;    
                    } else if (a[prop] < b[prop]) {    
                        return -1;    
                    }    
                    return 0;    
                }    
            }
            else{
                return function(a, b) {    
                    if (a[prop] < b[prop]) {    
                        return 1;    
                    } else if (a[prop] > b[prop]) {    
                        return -1;    
                    }    
                    return 0;    
                }  
            }
        },
        GetSortOrder_for_strings(prop,order) {
            if(order){
                return function(a, b) {   
                    if (a[prop].toLowerCase() > b[prop].toLowerCase()) {    
                        return 1;    
                    } else if (a[prop].toLowerCase() < b[prop].toLowerCase()) {    
                        return -1;    
                    }    
                    return 0;    
                }    
            }
            else{
                return function(a, b) { 
                    if (a[prop] < b[prop]) {    
                        return 1;    
                    } else if (a[prop].toLowerCase() > b[prop].toLowerCase()) {    
                        return -1;    
                    }    
                    return 0;    
                }  
            }
        }   
     
    }
}